import { BYTE_PREFIX } from "./data";

export type RequestPeriod = {
    start: string|Date
    stop: string|Date
}
export type RequestAOI = any;

export const REQUEST_TYPES = [ 'service', 'project', 'dcr' ];


export const check_request = (request:any) =>{
    const required = [ 'name', 'mission', 'instrument' ];
    for(let r of required){
        if(!request[r]){
            throw { type: 'warning', message: `Missing ${r}.` }
        }
    }
}


export const format_request_data = (data: any) =>{
    // if(data.volume && data.volume_suffix){
    //     data.volume = parseFloat(data.volume) * Math.pow(1024, BYTE_PREFIX.indexOf(data.volume_suffix || 0));
    //     delete data.volume_suffix;
    // }
    if(data.volume && data.volume_suffix){
        data.volume = parseFloat(data.volume) * Math.pow(1000, BYTE_PREFIX.indexOf(data.volume_suffix || 0));
        delete data.volume_suffix;
    }
}